import { RootStateDesktop } from "@desktop/store/configureStore";
import { RootStateMobile } from "@mobile/store/configureStore";

export type TUserState =
  | Pick<RootStateDesktop, "user">
  | Pick<RootStateMobile, "user">;

export const hasUser = (user: TUserState) =>
  user.user ? user.user.active : false;
